export default {
  featuredExperiences: 'Nuestras Experiencias Destacadas',
  searchAllExperiences: 'Buscar todas las Experiencias',
  searchAll: 'Buscar Todo ',
  groupSize: 'Tamaño del Grupo',
  eventSize: 'Tamaño del Evento',
  upTo: 'Hasta',
  whatWeDo: 'Qué Haremos',
  hostedBy: 'El Anfitrión es',
  whatsIncluded: 'Qué Incluye',
  avail: 'Disponibilidad',
  whereWeAre: 'Dónde Estaremos',
  experienceCalendar: 'Calendario de experiencia',
  experienceCancelled: 'Experiencia cancelada',
  experienceStartingPrice: 'Desde {{price}}',
  experienceTotalPrice: 'experienceTotalPrice',
  at: 'a las',
  viewPrivateSessAvailability: 'Ver la disponibilidad de las sesiones privadas',
  selectSession: 'Seleccionar Sesión',
  sessionsCount: '{{count}} horarios — elige un horario',
  noAvailability: 'No disponible',
  select: 'Seleccionar',
  slotLeft: '{{remainSlots}} espacio restante',
  slotsLeft: 'Quedan {{remainSlots}} espacios disponibles',
  spotsLeft: '{{count}} restantes',
  spotsLeftAriaLabel: '{{count}} plazas restantes',
  bookExperience: 'Reservar una Experiencia',
  book: 'Reservar',
  learnMore: 'Más información',
  apply: 'Aplicar',
  maxPartySizes: 'Máximo de {{maxGroupSize}} espacio por grupo',
  maxPartySize: 'Máximo de {{maxGroupSize}} tiempo por grupo',
  selectSessionValidation: 'Por favor, selecciona sesión',
  selectParticipantValidation: 'Por favor, selecciona los participantes',
  selectDateValidation: 'Por favor, selecciona una fecha',
  reminders: 'Avisos',
  seeOtherDates: 'Ver otras fechas',
  location: 'Ubicación',
  about: 'Detalles',
  allExperiences: 'Todas las experiencias',
  soldOut: 'Agotado',
  reviews: 'Reseñas',
  reviewSingular: 'reseña',
  reviewPlural: 'reseñas',
  dateOfExperience: 'Fecha de la experiencia',
  readLess: 'Leer Menos',
  readMore: 'Leer Más',
  seeMore: 'Ver Más',
  details: 'Detalles',
  durationHour: 'hora',
  durationHours: 'horas',
  durationMinutes: 'min',
  theFollowingVideoDoesNotContainAnyAudio: 'Este video no contiene audio',
  by: 'Por',
  chooseATime: 'Elige un horario para {{title}}',
  amenities: 'Amenidades',
  ticketSalesOpenIn: 'La venta de entradas comienza en',
  ticketSalesOpen: 'Venta de entradas abierta',
  ticketSalesCloseIn: 'La venta de entradas termina en',
  ticketSalesClose: 'Venta de entradas cerrada',
  ticketSalesClosed: 'La venta de entradas ha finalizado',
  comingSoon: 'Próximamente',
  inPartnershipWith: 'En colaboración con',
  notFoundExperienceTitle: 'Esta experiencia ya no está disponible',
  notFoundExperienceSubtitle:
    'Es posible que haya sido despublicada o que el enlace ya no sea válido.',
  deadLinkRecoverySubtitle:
    'Descubre otras experiencias disponibles para reservar',
  viewAllExperiences: 'Ver todas las experiencias',
  experienceBenefits: {
    benefits: {
      basePointsEarn:
        '<p><strong>Gane 5 Puntos Base</strong> por cada dólar estadounidense atribuible gastado al iniciar sesión en su cuenta de World of Hyatt para reservar esta experiencia</p>',
      basePoints:
        '<p><strong>Gane 10 Puntos Base</strong> por cada dólar estadounidense atribuible gastado al iniciar sesión en su cuenta de World of Hyatt para reservar esta experiencia</p>',
      additionalBonusPoints:
        '<p><strong>Gane 4 Puntos de Bonificación adicionales</strong> por cada dólar estadounidense atribuible al reservar con su tarjeta de crédito World of Hyatt</p>',
      additionalBonusPointsTier:
        '<p><strong>Gane hasta un 30% de Puntos de Bonificación adicionales</strong> según su estatus de nivel de membresía</p>',
      payWithPoints:
        '<p><strong>Pague con puntos</strong> al reservar esta experiencia</p>',
    },
  },
};
